const STATUSES_AR = {
  added: "مضاف",
  archived: "مؤرشف",
  canceled: "ملغى",
  complete: "مكتمل",
  confirmed: "قادِم",
  ended: "منتهي",
  expired: "منتهي الصلاحية",
  expires_soon: "ستنتهي قريبًا",
  incomplete: "غير مكتمل",
  paid: "مدفوع",
  paymentToCome: "دفعة قادمة",
  pending: "قيد الانتظار",
  proposed: "مقترح",
  refused: "مرفوض",
  scheduled: "قيد المعالجة",
  sent: "قيد المعالجة",
  started: "بدأ",
  to_add: "لإضافة",
  to_renew: "للتجديد",
  toAdd: "لإضافة",
  toCome: "قادِم",
  toCorrect: "للتصحيح",
  toJustify: "للتبرير",
  toPay: "للدفع",
  up_to_date: "محدث",
  validated: "تم التحقق",
  validationInProgress: "التحقق قيد التنفيذ",
  waiting_for_confirmation: "قادِم",
  waiting_for_validation: "قيد التنفيذ",
} as const;

export default STATUSES_AR;
